import { configureStore } from "@reduxjs/toolkit";
import { emptyApi } from "../api/emptyOldApi";
import { emptyV2Api } from "../api/emptyV2Api";
import { emptyAdminApi } from "../api/admin/emptyAdminApi";

export const store = configureStore({
  reducer: {
    // Add API reducers here
    [emptyApi.reducerPath]: emptyApi.reducer,
    [emptyV2Api.reducerPath]: emptyV2Api.reducer,
    [emptyAdminApi.reducerPath]: emptyAdminApi.reducer,  /* authenticated admin api */
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    // Add middleware here
    emptyApi.middleware,
    emptyV2Api.middleware,
    emptyAdminApi.middleware,  /* authenticated admin api */
  )
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
